<script>
  import Router from 'svelte-spa-router'
  import ProjectPreview from './project-preview/ProjectPreview.svelte'
  import Header from '../components/header/Header.svelte'
  import Footer from '../components/footer/Footer.svelte'
  import ProjectListing from './project-listing/ProjectListing.svelte'
  import ParticipateModal from '../components/modals/ParticipateModal.svelte'
  import Loader from '../components/loader/Loader.svelte'
  import ExploreProjects from './explore-projects/ExploreProjects.svelte'
  import { defaultEvmStores } from 'svelte-ethers-store'
  import Permissionless from './permissionless/Permissionless.svelte'
  import SaleListing from './permissionless/sale-listing/SaleListing.svelte'
  import SaleDetail from './permissionless/sale-listing/sale-detail/SaleDetail.svelte'
  import DutchAuction from './permissionless/dutch-auction/DutchAuction.svelte'
  import { onMount } from 'svelte'
  import PrivacyPolicy from './privacy-policy/PrivacyPolicy.svelte'
  import TermsConditions from './terms-conditions/TermsConditions.svelte'
  import HelpCenter from './help-center/HelpCenter.svelte'
  import StartProject from './permissionless/start-project/StartProject.svelte'
  onMount(() => {
    window.scrollTo(0, 0)
  })

  const routes = {
    '/': ProjectListing,
    '/launch-app': ProjectListing,
    '/explore-projects': ExploreProjects,
    '/permissionless': Permissionless,
    '/permissionless/:projectId': Permissionless,
    '/project-details/:projectId': ProjectPreview,
    '/sale-listing': SaleListing,
    '/sale-detail/:projectId/:address': SaleDetail,
    '/sale-detail': SaleDetail,
    '/sale-detail/:projectId': SaleDetail,
    '/dutch-auction': DutchAuction,
    '/privacy-policy': PrivacyPolicy,
    '/terms-conditions': TermsConditions,
    '/help-center': HelpCenter,
    '/start-project': StartProject,
  }

  let modalStatus = false
  const modalAction = () => {
    modalStatus = !modalStatus
  }

  onMount(async () => {
    if (window.ethereum) {
      const accounts = await window.ethereum.request({
        method: 'eth_accounts',
      })

      if (accounts.length) defaultEvmStores.setBrowserProvider().catch(() => {})

      window.ethereum.on('accountsChanged', () => window.location.reload())

      window.ethereum.on('chainChanged', () => {
        if (window.location.href.includes('project-details'))
          window.location.reload()
      })
    }
  })
</script>

<style>
  .launchpad-wrapper {
    width: 100%;
    overflow: hidden;
  }
  .sidebar-outer-wrapper {
    width: 100%;
    flex: 0 0 280px;
    max-width: 280px;
  }
  .content-wrapper {
    padding-top: 82px;
    width: 100%;
  }
  .inner-content-wrapper {
    max-width: 1536px;
    width: 100%;
    margin: 0 auto;
  }
  @media screen and (max-width: 1190px) {
    .content-wrapper {
      padding-top: 54px;
    }
    .sidebar-outer-wrapper {
      flex: unset;
      max-width: unset;
      width: unset;
    }
    .content-wrapper {
      width: 100%;
    }
  }
</style>

<div class="launchpad-wrapper">
  <div class="content-wrapper">
    <Header on:modalAction={modalAction} />
    <div class="inner-content-wrappe">
      <Loader />
      <Router {routes} />
      <ParticipateModal {modalStatus} on:modalAction={modalAction} />
    </div>
  </div>
  <Footer />
</div>
